import { useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Login is the unauthenticated entry point. On success it redirects to the page
// the user originally requested, or to the landing page their role and grants
// imply (Billing for a member, Console home for a superadmin).
export default function Login() {
  const { login, isAuthenticated, loading, landing } = useAuth();
  const location = useLocation();
  // The redirect is a render, not a navigate() call: `landing` is read from the
  // grants, and those only arrive once the sign-in has resolved.
  const from = location.state?.from?.pathname || landing;

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Already signed in? Skip the form.
  if (!loading && isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login(form.email.trim(), form.password);
      // Leave `submitting` set: the render above takes over from here, and
      // clearing it would flash an enabled button under the redirect.
    } catch (err) {
      setError(err.message || 'Sign in failed');
      setSubmitting(false);
    }
  };

  return (
    <div className="login">
      <div className="login__card">
        <img
          className="login__logo"
          src={`${process.env.PUBLIC_URL}/assets/toffs_logo.png`}
          alt="Toffs Cloud"
        />
        <h1 className="login__title">Sign in</h1>
        <p className="login__sub">Access your Toffs Cloud console</p>

        <form className="form" onSubmit={submit}>
          <label className="field">
            <span>Email</span>
            <input
              className="input"
              type="email"
              autoComplete="username"
              placeholder="you@company.com"
              value={form.email}
              onChange={update('email')}
              required
              autoFocus
            />
          </label>

          <label className="field">
            <span>Password</span>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={form.password}
              onChange={update('password')}
              required
            />
          </label>

          {error ? <div className="form-error">{error}</div> : null}

          <button
            type="submit"
            className="btn btn--primary login__submit"
            disabled={submitting}
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
